// Keeping this here in case the list of disallowed characters needs to be modified
const REGEX_DISALLOWED_EMAIL_CHARACTERS = '[^\\0"#%\'()+/;<>?@\\\\|\\s]'
const VALID_REGEX_EMAIL_ADDRESS = ['^', REGEX_DISALLOWED_EMAIL_CHARACTERS, '+(\\+', REGEX_DISALLOWED_EMAIL_CHARACTERS, '+)?@([A-Za-z0-9]+([-.]*[A-Za-z0-9]*)*)+$'].join('')
console.log("Regex string is ".concat(VALID_REGEX_EMAIL_ADDRESS))
export const RegularExpressions = Object.freeze({
	ValidEmailAddress: new RegExp(VALID_REGEX_EMAIL_ADDRESS, 'i')
})